import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import ScyllaDB from "../../homepage/header-banner/ScyllaDB";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../container/Sidebar/sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard";
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute";
import CardBox from "../../container/Box/Components/CardBox";
// import { MuiGrid } from '@mui/material';
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import DividerComponent from "../../container/Divider/divider";
import styled from "styled-components";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloudVN from "../../container/Banner/banner-privateCloud-vn";
import Cloudconsult2VN from "../../homepage/consult/cloudconsult-2-vn";
import SidebarVN from "../../container/Sidebar/Sidebar-vn";
import HeaderVn from "../../detailpageVN/Page/component/headervn";
import FooterVn from "../../detailpageVN/Page/component/footervn";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

function ClustercloudscylladbVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Private ScyllaDB Cluster - Private Kubernetes - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for ScyllaDB")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Cơ sở dữ liệu NoSQL tương thích với Cassandra, được triển khai trên nền tảng cluster Kubernetes.</p>",
                                    `<p class='typo-14'>Phát triển bằng C++ dựa trên framework Seastar, mang lại khả năng tương thích cao với Cassandra.</p>
                                <p class='typo-14'>Được thiết kế để đạt hiệu suất cao hơn nhiều lần so với Cassandra truyền thống.</p>
                                <p class='typo-14'>Cluster ScyllaDB bao gồm các Node và Shard, hỗ trợ khả năng mở rộng linh hoạt và hiệu quả (scale out).</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Vận hành Persistent Volume với hiệu suất cao, tối ưu hóa khả năng truy xuất I/O.</p>",
                                    `<p class='typo-14'>Hệ thống sử dụng volume PV SSD, gồm 3 container replica (POD) cấu thành một đơn vị dịch vụ.</p>
                                <p class='typo-14'>Ngay cả khi phần cứng của một worker node trong Kubernetes gặp sự cố, dịch vụ vẫn được duy trì và tiếp tục vận hành trên các container (POD) thuộc các worker node khác.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động di chuyển container (POD) khi xảy ra sự cố phần cứng, đảm bảo hoạt động liên tục và không bị gián đoạn.</p>",
                                    `<p class='typo-14'>Các container (POD) của Kubernetes ScyllaDB bao gồm 3 node replica cho mỗi dịch vụ đơn vị.</p>
                                <p class='typo-14'>Các replica container được phân bổ trên nhiều worker node trong Kubernetes, giúp tăng cường khả năng chịu lỗi và tính sẵn sàng của hệ thống.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống hỗ trợ tự động mở rộng quy mô (autoscaling), cho phép mở rộng container nhằm phân phối tải dịch vụ hiệu quả.</p>",
                                    `<p class='typo-14'>Số lượng container (POD) được điều chỉnh định kỳ dựa trên các chỉ số như CPU, bộ nhớ hoặc các metric tùy chỉnh khác.</p>
                                <p class='typo-14'>Việc mở rộng không đòi hỏi phải bổ sung thêm tài nguyên phần cứng.</p>
                                <p class='typo-14'>Đây là giải pháp cluster tối ưu trong việc phân phối tải và giảm thiểu chi phí vận hành dịch vụ.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>
                                {Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-cloud-scylladb/scylla_cluster.svg")}
                            </MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        {/* <ScyllaDB /> */}
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
}

const MuiGrid = styled.div`
    padding: 0px;
`;

export default ClustercloudscylladbVN;
